import moment from "moment"
import merge from "lodash/merge"

export default function () {

  let axislabels = {
    style: {
      fontSize: '14px',
      color: '#2c2c2c',
      fontFamily: 'Roboto',
      fontWeight: '300',
    }
  };

  let defaultConfig = {

    credits: {enabled: false},
    chart: {
      type: 'areaspline',
      backgroundColor: 'none',
      zoomType: 'x',
      height: 260,
      // animation: false,
      resetZoomButton: {
        position: {
          x: 9,
          y: -7
        },
        theme: {
          fill: 'none',
          style: {
            color: '#000000'
          },
          stroke: {
            width: 0,
          },
          states: {
            hover: {
              fill: 'transparent',
              style: {
                color: '#000000'
              }
            }
          }
        }
      }
    },
    time: {
      useUTC: true
    },
    title: {
      text: '',
      align: 'left',
      /*style: {
          fontWeight: 'bold',
          color: '#2c2c2c',
          fontSize: '16px',
          textTransform: 'uppercase',
          fontFamily: 'Roboto',
          //margin: '15px'
      },*/
    },
    xAxis: {
      type: "datetime",
      tickLength: 0,
      lineColor: 'transparent',
      dateTimeLabelFormats: {
        hour: '%H:%M'
      },
      crosshair: {
        color: '#333333',
        dashStyle: 'solid',
        width: 2
      },
      labels: axislabels,
      min: new Date().setHours(0, 0, 0, 0),
      max: new Date().setHours(23, 59, 59, 999),
    },

    yAxis: {
      gridLineWidth: 1,
      title: {
        text: ''
      },
      labels: {
        // formatter: function () {
        //     return this.value;
        // },
        // format: '{value} ',
        style: axislabels.style
      }
    },
    tooltip: {
      backgroundColor: 'rgba(40, 40, 40, 0.7)',
      borderColor: 'none',
      borderRadius: 20,
      shadow: false,
      padding: 5,
      style: {
        color: '#f4f4f4',
        fontSize: '14px',
        fontFamily: 'Roboto'
      },
      shared: true,
      useHTML: true,

      formatter: function () {
        let pointsMarkup = [];
        let x = this.points[0].x;

        pointsMarkup.push(`<div style="text-align: center; text-transform:uppercase;margin-bottom:10px;font-weight:bold;">` + moment(x).format('MMM D, h:mm A') + `</div>`);

        for (let point of this.points) {
          pointsMarkup.push(`<div class="d-flex justify-content-between">`);
          pointsMarkup.push(`<div style="margin-bottom:6px">` + point.series.name + `</div>`);
          pointsMarkup.push(`<div style="margin-bottom:6px"> &nbsp;` + point.y + `</div>`);
          pointsMarkup.push(`</div>`);
        }


        return pointsMarkup;
      }
    },
    legend: {
      align: 'left'
    },
    plotOptions: {
      // area: {
      //     showInLegend: false,
      //     marker: {
      //         enabled: false,
      //         symbol: 'circle',
      //         radius: 2,
      //         states: {
      //             hover: {
      //                 enabled: true
      //             }
      //         }
      //     }
      // }
      areaspline: {
        showInLegend: false,
        fillOpacity: 0.5,
        marker: {
          enabled: false
        }
      }
    },
    series: []
  };

  return {
    getDefaultConfig: function () {
      return Object.assign({}, defaultConfig)
    },

    initializeWithOptions: function (options) {
      return merge(Object.assign({}, defaultConfig), options)
    }
  }
}


//Highcharts.dateFormat(' %b %e, %H:%M %P', new Date(x))


// WEBPACK FOOTER //
// ./src/highchartsConfigDefault/areaChartConfig.js